import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/onboarding`;

/**
 * Normalize whatever the user typed into a 9-digit ΑΦΜ.
 * Accepts "EL803335274", "GR 803 335 274", " 803335274 ", etc.
 * Returns `null` if it doesn't look like a valid ΑΦΜ yet (so callers
 * can debounce and only fire when the user has typed enough).
 */
export const normalizeAfm = (raw) => {
  if (!raw) return null;
  const cleaned = String(raw).replace(/\s+/g, '').toUpperCase().replace(/^(EL|GR)/, '');
  if (!/^\d{9}$/.test(cleaned)) return null;
  return cleaned;
};

/**
 * Look up a Greek business by ΑΦΜ through the AADE RgWsPublic2 proxy.
 * Returns `{ok:true, data}` on success or `{ok:false, code, message}`
 * on error so the caller can render a specific message.
 */
export async function lookupVat(afmInput) {
  const afm = normalizeAfm(afmInput);
  if (!afm) return { ok: false, code: 'INVALID_AFM', message: 'ΑΦΜ must contain 9 digits' };

  try {
    const { data } = await axios.post(`${API}/vat-lookup`, { afm });
    return { ok: true, data: data.data };
  } catch (err) {
    const detail = err.response?.data?.detail;
    const code = detail?.code || 'AADE_ERROR';
    const message = detail?.message || 'AADE lookup failed';
    return { ok: false, code, message };
  }
}
